import { Directive, ElementRef, Renderer2, inject } from '@angular/core';
import { TEXT_DIRECTION_TOKEN } from '@app/app.tokens';

@Directive({
  selector: '[sharedTextDirection]',
  standalone: false,
})
export class TextDirectionDirective {
  private textDirection = inject(TEXT_DIRECTION_TOKEN);
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  constructor() {
    this.renderer.setAttribute(
      this.el.nativeElement,
      'dir',
      this.textDirection
    );
  }
}
